// @flow

export type Config = {
    historyMinVersion: string,
    version: string,
    historyMaxCount: number,
    urlCalcProject: string,
    urlHistory: string,
    simulateLoggedInUser: boolean,
    adminEmails: string[]
};

const config: Config = {
    version: '1.7.1',
    historyMinVersion: '0.9.4',
    historyMaxCount: 10,
    urlCalcProject: '/api/Calculation/CalculateProject',
    urlHistory: '/api/Calculation/CalculationRequestInfo',
    simulateLoggedInUser: false,
    // Also need to set admin user guids in CalculationController.cs if modified
    adminEmails: [
        "rickard.winberg@PollexAB.onmicrosoft.com",
        "mattias.hoglund@pollex.se",
        "maria.stromback@pollex.se"
    ]
};

export default config;


// WEBPACK FOOTER //
// ./src/common/Config.js